<input
  type="file"
  class="file-input"
  [accept]="config.accept || requiredFileType"
  (change)="onFileSelected($event)"
  #fileUpload />
<div fxFlexLayout="row" fxLayoutGap="4" class="file-upload">
  <label fxFlex="initial" class="title">{{ config.label }}:</label>

  <!-- Nome do arquivo com link para visualização e download (modo SHOW) -->
  <label *ngIf="fileName && typeCes == typeCesEnum.SHOW" fxFlex class="value">
    <a [href]="downloadFile()" (click)="downloadFileDirectly($event)"
      class="file-download-link"
      title="Clique para baixar o arquivo">
      <mat-icon class="file-icon">download</mat-icon> {{ fileName }}
    </a>
  </label>

  <!-- Nome do arquivo clicável para upload (modo EDIT) -->
  <label
    *ngIf="fileName && typeCes != typeCesEnum.SHOW"
    fxFlex
    class="value file-name"
    (click)="fileUpload.click()">
    <mat-icon class="file-icon">description</mat-icon> {{ fileName }}
  </label>

  <!-- Mensagem quando não há arquivo -->
  <label *ngIf="!fileName" fxFlex class="value no-file">{{
    config.placeholder || messagesEnum.NO_FILE_UPLOADED_YET
    }}</label>

  <!-- Botão de upload (quando não há arquivo) -->
  <button
    *ngIf="!fileName && typeCes !== typeCesEnum.SHOW"
    fxFlex="initial"
    mat-mini-fab
    color="primary"
    class="upload-btn"
    (click)="fileUpload.click()">
    <mat-icon>attach_file</mat-icon>
  </button>

  <!-- Botão de cancelar (quando há arquivo no modo edição) -->
  <button
    *ngIf="fileName && typeCes !== typeCesEnum.SHOW"
    fxFlex="initial"
    mat-mini-fab
    color="primary"
    class="upload-btn"
    (click)="cancelFile()">
    <mat-icon>close</mat-icon>
  </button>
</div>
